<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <circle cx="6.75" cy="3.75" r="3" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M12.75 12.4686C12.75 14.0261 10.0637 14.5156 6.75 14.5156C3.43629 14.5156 0.75 13.9874 0.75 12.4686C0.75 9.73316 3.43629 7.51562 6.75 7.51562C10.0637 7.51562 12.75 9.73316 12.75 12.4686Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconPatientsSearch'
}
</script>
